"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classNames_1 = __importDefault(require("../../../lib/classNames"));
var lib_1 = require("../Image/lib");
var UploadcareSvg = function (props) {
    var className = props.className, alt = props.alt, layout = props.layout, objectFit = props.objectFit, width = props.width, height = props.height, objectPosition = props.objectPosition, lazy = props.lazy;
    var image = lib_1.getPictureDetails(props).image;
    var imageStyle = layout === 'fixed'
        ? undefined
        : {
            objectFit: objectFit,
            objectPosition: objectPosition,
            maxHeight: height,
            maxWidth: width,
            minHeight: height,
            minWidth: width,
        };
    return (react_1.default.createElement("img", { className: classNames_1.default(className, 'uploadcare-image__image', layout === 'fill' && 'uploadcare-image__layout-fill'), loading: lazy ? 'lazy' : 'eager', alt: alt, style: imageStyle, src: image.src }));
};
exports.default = UploadcareSvg;
//# sourceMappingURL=UploadcareSvg.js.map